import { Box, Button, Typography } from '@mui/material'
import { usePermissions } from 'hooks/use-permissions'
import { useLazyLoadChildDuplicateQuery } from 'slices/duplicateChildSlice'
import { useNavigate } from 'react-router'
import { DUPE_MANAGEMENT } from 'Pages/Routes'

export interface DuplicateDisclaimerProps {
  pendingDuplicateID: number
}

export function DuplicateDisclaimer (props: DuplicateDisclaimerProps): JSX.Element {
  const [getDuplicateDetails] = useLazyLoadChildDuplicateQuery()
  const perms = usePermissions()
  const nav = useNavigate()

  const redirectToDuplicate = async (): Promise<void> => {
    const { data: childDupeRecord } = await getDuplicateDetails(props.pendingDuplicateID ?? 0)
    if (childDupeRecord != null) {
      nav(DUPE_MANAGEMENT)
    }
  }

  return <>
    {perms.ISDs_DuplicateHandling
      ? <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        <Typography variant='body2' color='textSecondary' align='center'> A duplicate record for this child is pending review so it cannot be edited.  You can use the following link to review it.</Typography>
        <Button data-testid='gotoChild' sx={{ textTransform: 'none', textDecoration: 'underline', color: 'black' }} onClick={redirectToDuplicate}>View Duplicate Details</Button>
      </Box>
      : <Typography variant='body2' color='textSecondary' align='center'> A duplicate record for this child is pending review.  A user with duplicate handling permission must resolve the pending duplicate before edits can be made.</Typography>
    }
  </>
}
